var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgControlForward24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.82181815,13.4509091 L18.0654545,13.4509091 L10.9636364,20.5527273 C10.595328,20.9190869 10.4504476,21.4541074 10.5835702,21.9562515 C10.7166927,22.4583958 11.1075938,22.851376 11.6090247,22.9871606 C12.1104556,23.1229452 12.6462371,22.9809051 13.0145455,22.6145455 L22.6036364,13.0909091 C23.1695944,12.5244069 23.1695944,11.6065022 22.6036364,11.04 L13.0145455,1.3963636 C12.4433981,0.85957956 11.5491805,0.873443618 10.9949484,1.42767568 C10.4407164,1.98190775 10.4268524,2.87612539 10.9636364,3.44727271 L18.0654545,10.5490909 L1.82181815,10.5490909 C1.30345824,10.5490909 0.82447392,10.8256325 0.56529396,11.2745455 C0.306114,11.7234583 0.306114,12.2765417 0.56529396,12.7254545 C0.82447392,13.1743675 1.30345824,13.4509091 1.82181815,13.4509091 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconActionForward24",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconActionForward32"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color",
    mask: "url(#mask-2)",
    fill: "#282828",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.454545, -5.454545)",
    id: "Rectangle-Copy-11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 34.9090909,
    height: 34.9090909
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlForward24);
export default __webpack_public_path__ + "static/media/controlForward24.894a12baa9db33b6e4b5c097d2ac3aeb.svg";
export { ForwardRef as ReactComponent };